"use client";
import { CommonSubHeader } from "../../components/CommonSubHeader";
import { usePathname, useRouter } from "next/navigation";
import { useMemo } from "react";
import { generalLiterals } from "literals";

const { marketplaceLayout } = generalLiterals;

export default function MarketplaceLayout({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element {
  const pathname = usePathname();
  const router = useRouter();

  const { isBackButtonActive, title, subtitle } = useMemo(
    () =>
      pathname.includes("buy-nfts/0x")
        ? {
            isBackButtonActive: true,
            title: marketplaceLayout.titleItemDetails,
            subtitle: null,
          }
        : pathname.includes("list-for-sale")
        ? {
            isBackButtonActive: false,
            title: marketplaceLayout.titleListForSale,
            subtitle: null,
          }
        : {
            isBackButtonActive: false,
            title: marketplaceLayout.titleGeneral,
            subtitle: marketplaceLayout.subheader,
          },
    [pathname]
  );

  const handleBackClick = () => router.push("/marketplace");

  return (
    <>
      <main className="relative overflow-hidden pb-16">
        <CommonSubHeader>
          {isBackButtonActive && (
            <CommonSubHeader.BackButton onClick={handleBackClick} />
          )}
          <CommonSubHeader.SubHeaderH1>{title}</CommonSubHeader.SubHeaderH1>
          {subtitle && (
            <CommonSubHeader.SubHeaderH2>
              <span className="flex justify-center">
                <span className="block w-[480px] font-normal">{subtitle}</span>
              </span>
            </CommonSubHeader.SubHeaderH2>
          )}
        </CommonSubHeader>
        {/* {isNavBarActive && (
          <div className="mb-14 flex flex-col items-center justify-center">
            <NavBar className="mb-14" />
          </div>
        )} */}
        {children}
      </main>
    </>
  );
}
